import { SongDO } from "../data/SongDO";
import { StudentManager } from "../data/StudentManager";
import { AbstractPanelItem, SongPanelItem } from "./panel_items";
import { SongPanel } from "./SongPanel";
import { _SongSidebarEvent, _SongsSidebar } from "./_SongsSidebar";

export class _SongSection {
	private _container:HTMLDivElement;
	
	private _sidebar:_SongsSidebar;
	private _panel:SongPanel;
	private _librarySongs:Array<SongDO> = [];
	
	constructor(container:HTMLDivElement){
		this._container = container;
		this._init();
	}
	
	private async _init():Promise<void> {
		this._initializeSidebar();
		this._initializePanel();
		await this._getLibrarySongs();
		
		this._sidebar.event.on(this._onSidebarEvent);
		
		//call init here so we can respond to the sidebar's content request
		this._sidebar.init();
	}
	
	public updateAssessmentScores():void {
		this._updateAssessmentScores();
	}
	
	private _initializeSidebar():void {
		let sidebarDiv = this._container.querySelector(".m-panel-sidebar") as
			HTMLDivElement;
		this._sidebar = new _SongsSidebar(sidebarDiv);
	}
	
	private _initializePanel():void {
		let sectionDiv = this._container.querySelector(".m-panel-section");
		let panelDiv = sectionDiv.querySelector(".m-hpanel") as HTMLDivElement;
		let navDiv = sectionDiv.querySelector(".m-hpanelnav") as HTMLDivElement;
		this._panel = new SongPanel(panelDiv, navDiv,
			{ navQueryPrefix: "lib" });
	}
	
	private async _getLibrarySongs():Promise<void> {
		this._librarySongs = [];
		let librarySongsJson:any[] = window['librarySongs'];
		for (let songJson of librarySongsJson){
			let catId:string = songJson['catId'];
			let sdo = SongDO.fromLibrarySongJson(catId, songJson);
			this._librarySongs.push(sdo);
		}
	}
	
	private _onSidebarEvent = (e:_SongSidebarEvent):void => {
		let sdoList:Array<SongDO>;
		
		if (e.type === _SongSidebarEvent.CategoryRequest){
			sdoList = this._librarySongs.filter((ls) => {
				return (ls.categoryId === e.categoryId);
			});
		}
		this._displaySongs(sdoList, 0);
		this._updateAssessmentScores();
	}
	
	private _displaySongs(songDOList:SongDO[], displayIndex:number):void {
		this._panel.resetPanel();
		this._panel.maxItemIndex = songDOList.length;
		
		let items:AbstractPanelItem[] = [];
		let index:number = 0;
		for (let sdo of songDOList){
			let item = new SongPanelItem(sdo);
			item.index = index;
			items.push(item);
			index++;
		}
		
		this._panel.addPanelItems(items);
		this._panel.displayFromIndex(displayIndex);
	}
	
	private _updateAssessmentScores():void {
		let student = StudentManager.currentStudent;
		let items = this._panel.getAllPanelItems();
		for (let item of items){
			let msItem = item as SongPanelItem;
			let score:number = (student != null)
				? student.scores.get(msItem.songDO.libId)
				: null;
			msItem.updateAssessmentScore(score, student != null);
		}
	}
}